import axiosInstance from "./request";

export const LoginApi = (value: any) => {
  return axiosInstance.post("/auth/user/login", value);
};
